/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * counter box
 * ======================================================================== 
 * 1/15/2016: creation
 * 5/2/2016: new parent handler
*/


FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="counter"]';


    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 52,
        value: 1,
        noedit: false,
        min: 1,
        max: 3        
    };



    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set event
        $(document).off('click', ELEM);
        $(document).on('click.' + NAMESPACE, ELEM, clickCounter);
    }


    //  get counter box
    function getCounter(wireEvent, container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }
        

        //  wire events
        if (wireEvent) setEvents();


        //  bail
        if (list.length === 0) return;


        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());


            //  set elem data
            me.setControlItemOptions(elem, options);


            //  set data
            elem.data(options);
            elem.addClass('counter-container').html('').append("<span class='counter-child'>" + options.value + "</span>");

            //  no edit
            if (options.noedit) {
                elem.css({ cursor: 'default' });
            } else {
                elem.css({ cursor: 'pointer' });
            }
        });
    }


    //  click counter
    function clickCounter() {
        var e = $(this);
        e.data().element = e;

        var data = e.data();

        //  no edit
        if (data.noedit) return;

        var value = data.value;
        var min = data.min;
        var max = data.max;
      
        if (value >= max) {
            value = min;
        } else {
            value++;
        }
        
        e.data().value = value;
        e.children('span').html(value);

        //  callback
        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
    }



    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set counter
    child.setCounter = function (wireEvent, container) {       
        getCounter(wireEvent, container);
    }


    

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));

